import React from "react";
import { Shield, LogOut, User } from "lucide-react";
import Button from "./ui/Button";

interface UserMenuProps {
  user: any;
  isSigningOut: boolean;
  onSignOut: () => void;
}

const UserMenu: React.FC<UserMenuProps> = ({
  user,
  isSigningOut,
  onSignOut,
}) => {
  const [open, setOpen] = React.useState(false);
  const menuRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  return (
    <div className="relative isolate" ref={menuRef}>
      {/* Avatar Wrapper (never inherits styles) */}
      <div
        onClick={() => setOpen((prev) => !prev)}
        className="
          w-10 h-10 rounded-full 
          bg-gray-700 hover:bg-gray-600 
          flex items-center justify-center 
          cursor-pointer
          overflow-hidden
          shrink-0
          !p-0 !m-0
          relative
          isolate
        "
        style={{
          pointerEvents: "auto",
        }}
      >
        {/* FORCED ICON – cannot be overridden */}
        <User
          className="w-5 h-5 text-gray-200 pointer-events-none"
          style={{ display: "block", position: "relative", zIndex: 10 }}
        />
      </div>

      {open && (
        <div
          className="
            absolute right-0 mt-2 
            w-56 p-3 
            bg-gray-800 border border-gray-700 
            rounded-lg shadow-lg 
            z-50
          "
        >
          <div className="flex items-center gap-2 px-2 py-1 text-gray-300">
            <Shield className="w-4 h-4" />
            <span className="text-sm truncate">{user?.email}</span>
          </div>

          <div className="border-t border-gray-700 my-2" />

          <Button
            variant="ghost"
            size="sm"
            loading={isSigningOut}
            loadingText="Signing out..."
            onClick={onSignOut}
            icon={<LogOut className="w-4 h-4" />}
            className="w-full justify-start"
          >
            Sign Out
          </Button>
        </div>
      )}
    </div>
  );
};

export default UserMenu;
